import ApiService from './ApiService';
import { TAdmin } from '@/types/admin';

class AdminRepository extends ApiService {
  constructor() {
    super('/admin/accounts');
  }

  async getAdminProfile(): Promise<TAdmin> {
    return await this.get<TAdmin>('/me');
  }
}

export default new AdminRepository();
